<ng-container *ngIf="data">
  <div class="anq-table-top">
    <app-page-size
      [pageSize]="pageSize"
      [recordsTotal]="totalRecords"
      (pageSizeChange)="onPageSizeChange($event)"
    ></app-page-size>

    <app-search-filter
      [searchTextPlaceholder]="'Search by Name'"
      [searchText]="searchText"
      [formGroup]="formGroup"
      [formFields]="formFields"
      (searchTextChange)="onSearchTextChange($event)"
      (filterTableEvent)="onFilterTable($event)"
    ></app-search-filter>
  </div>
  <div class="table-responsive">
    <table class="table table-bordered table-striped table-hover">
      <thead class="table_header">
        <tr>
          <!-- Debug headers -->
          <ng-container *ngIf="!headers.length">
            <th colspan="1" class="text-center">No headers available</th>
          </ng-container>
          <ng-container *ngFor="let header of headers">
            <th
              *ngIf="header.sortable; else nonSortable"
              (click)="sort(header.key)"
              class="sortable-header"
            >
              <span class="header-content">
                {{ header.label }}
                <i class="fa sort-icon" [ngClass]="getSortIcon(header.key)" aria-hidden="true"></i>
              </span>
            </th>
            <ng-template #nonSortable>
              <th>{{ header.label }}</th>
            </ng-template>
          </ng-container>
          <th *ngIf="hasAnyActions()">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data; let i = index">
          <ng-container *ngFor="let header of headers">
            <td *ngIf="header.key === 'status'; else defaultCell">
              <span  [ngClass]="getStatusClass(item[header.key])">{{ item[header.key] }}</span>
            </td>
            <ng-template #defaultCell>
              <td>{{ item[header.key] }}</td>
            </ng-template>
          </ng-container>
          <td *ngIf="getFilteredActionMenu(item).length > 0">
            <div ngbDropdown class="d-inline-block" container="body">
              <button
                type="button"
                class="elipses-btn"
                id="dropdownBasic{{i}}"
                ngbDropdownToggle
              >
                ...
              </button>
              <div ngbDropdownMenu [attr.aria-labelledby]="'dropdownBasic' + i">
                <a
                  *ngFor="let action of getFilteredActionMenu(item)"
                  class="dropdown-item action-area {{ action.styleClass }}"
                  (click)="onAction(item, action.action)"
                  ngbDropdownItem
                >
                  {{ action.label }}
                </a>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngIf="!data.length">
          <td [attr.colspan]="headers.length + (hasAnyActions() ? 1 : 0)" class="text-center">
            <app-empty-datatable></app-empty-datatable>
          </td>
        </tr>
      </tbody>
    </table>

    <app-pagination
      [pageNumber]="pageNumber"
      [pageSize]="pageSize"
      [itemsCount]="data.length"
      [recordsTotal]="totalRecords"
      [totalPages]="totalPages"
      (pageChange)="onPageChange($event)"
    ></app-pagination>
  </div>
</ng-container>

<style>
  /* Hide dropdown arrow for elipses-btn */
  ::ng-deep .elipses-btn::after {
    display: none !important;
  }

  .elipses-btn {
    background-color: transparent !important;
    border: none !important;
    padding: 0;
    font-size: 22px !important;
    font-weight: 600 !important;
    color: #282828 !important;
  }

  .dropdown-item.action-area {
    cursor: pointer !important;
  }
  /* Status badge styling */
  .active-bg, .inactive-bg {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: 0.5rem;
    font-weight: 500;
  }

  .active-bg {
    background-color: #e6ffe6 !important; /* Light green background */
    color: #34C759 !important; /* Green text to match active_span */
  }
  .inactive-bg {
    background-color: #ffe6e6 !important; /* Light red background */
    color: #FF2D55 !important; /* Red text to match deactivated_span */
  }

  /* Only status-related styling (for reference, can be removed if redundant) */
  .active_span {
    color: #34C759 !important;
  }
  .deactivated_span {
    color: #FF2D55 !important;
  }
  .deleted_span {
    color: #666666 !important;
  }
</style>